import React, { Fragment } from 'react';

const NotFound = () => {
  return (
    <Fragment>
      <div id="notfound">
        <i className="fas fa-exclamation-triangle" />
        <h1>Page Not Found</h1>
        <p className="">Sorry, this page does not exist</p>
      </div>
    </Fragment>
  );
};

export default NotFound;
